// import React, { useState, useEffect } from "react";

// const LanguageSwitcher = ({ onLanguageChange }) => {
//   const [language, setLanguage] = useState(localStorage.getItem("lang") || "el");

//   useEffect(() => {
//     localStorage.setItem("lang", language);
//     onLanguageChange(language);
//   }, [language, onLanguageChange]);

//   const toggleLanguage = () => {
//     console.log("clicked")
//     setLanguage((prev) => (prev === "el" ? "en" : "el"));
//   };

//   return (
//     <button onClick={toggleLanguage} style={styles.button}>
//       <img
//         src={language === "el" ? "./images/uk.png" : "./images/gr.png"}
//         alt={language === "el" ? "Switch to English" : "Switch to Greek"}
//         style={styles.flag}
//       />
//     </button>
//   );
// };

// const styles = {
//   button: {
//     background: "transparent",
//     border: "none",
//     cursor: "pointer",
//   },
//   flag: {
//     width: "30px",
//     height: "20px",
//   },
// };

// export default LanguageSwitcher;



// import React, { useState, useEffect } from "react";

// const LanguageSwitcher = ({ onLanguageChange }) => {
//   const [language, setLanguage] = useState(localStorage.getItem("lang") || "el");

//   useEffect(() => {
//     localStorage.setItem("lang", language);
//     onLanguageChange(language);
//   }, [language, onLanguageChange]);

//   const toggleLanguage = () => {
//     setLanguage((prev) => (prev === "el" ? "en" : "el"));
//   };

//   return (
//     <div style={styles.switchContainer} onClick={toggleLanguage}>
//       <div style={{ ...styles.switch, justifyContent: language === "el" ? "flex-start" : "flex-end" }}>
//         <img src="./images/gr.png" alt="Greek" style={styles.flag} />
//         <img src="./images/uk.png" alt="English" style={styles.flag} />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   switchContainer: {
//     width: "60px",
//     height: "30px",
//     borderRadius: "15px",
//     background: "#ddd",
//     display: "flex",
//     alignItems: "center",
//     cursor: "pointer",
//     padding: "2px",
//     transition: "background 0.3s",
//   },
//   switch: {
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     height: "100%",
//     background: "#fff",
//     borderRadius: "15px",
//     padding: "2px",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//     transition: "justify-content 0.3s ease",
//   },
//   flag: {
//     width: "24px",
//     height: "16px",
//     margin: "0 5px",
//   },
// };

// export default LanguageSwitcher;


import React, { useState, useEffect, useRef } from "react";

const LanguageSwitcher = ({ onLanguageChange }) => {
  const [language, setLanguage] = useState(localStorage.getItem("lang") || "el");
  const ref = useRef()

  useEffect(() => {
    localStorage.setItem("lang", language);
    onLanguageChange(language);
  }, [language, onLanguageChange]);

  useEffect(() => {
    ref.current.checked = language === 'en'
  }, []);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "el" ? "en" : "el"));
  };

  return (
    <div className="d-flex justify-content-end" onClick={toggleLanguage}>
      <div className="switch">
	    <input ref={ref} id="language-toggle" className="check-toggle check-toggle-round-flat" type="checkbox" onChange={toggleLanguage} />
	    <label htmlFor="language-toggle"></label>
	    <span className="on"><img src="./images/gr.png" alt="Greek" style={styles.flag} /></span>
	    <span className="off"><img src="./images/uk.png" alt="English" style={styles.flag} /></span>
  	    </div>
    </div>
  );
};

const styles = {
  switchContainer: {
    width: "70px",
    height: "35px",
    borderRadius: "18px",
    background: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "2px",
    transition: "background 0.3s ease",
    boxShadow: "inset 0 2px 5px rgba(0,0,0,0.1)",
  },
  switch: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "100%",
    borderRadius: "18px",
    padding: "2px",
    position: "relative",
    transition: "justify-content 0.3s ease, background 0.3s ease",
  },
  flagWrapper: {
    flex: 1,
    textAlign: "center",
    transition: "opacity 0.3s ease",
  },
  flag: {
    width: "24px",
    height: "16px",
  },
  knob: {
    position: "absolute",
    width: "30px",
    height: "30px",
    background: "#fff",
    borderRadius: "50%",
    boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
    transition: "transform 0.3s ease",
    transform: "translateX(0)",
    left: "4px",
  },
};

export default LanguageSwitcher;
